export default __webpack_public_path__ + "static/media/Clock_Hand_Min.185e97bc.svg";